import React from "react";
import { Link } from "react-router-dom";

import style from "./styles.module.scss";

interface ServiceCardProps {
  description: string;
  external?: boolean;
  href: string;
  icon: string;
  title: string;
}

export default function ServiceCard({
  description,
  external = false,
  href,
  icon,
  title,
}: ServiceCardProps) {
  const content = (
    <>
      <span aria-hidden="true" className={`material-symbols-sharp ${style.icon}`}>
        {icon}
      </span>

      <span className={style.infos}>
        <span className={`pgm-title-large ${style.title}`}>{title}</span>
        <span className={`pgm-body-large ${style.description}`}>{description}</span>
      </span>

      <span aria-hidden="true" className={`material-symbols-sharp ${style.trailing}`}>
        {external ? "open_in_new" : "arrow_forward"}
      </span>
    </>
  );

  if (external) {
    return (
      <a
        className={style.card}
        href={href}
        rel="noopener noreferrer"
        target="_blank"
      >
        {content}
      </a>
    );
  }

  return (
    <Link className={style.card} to={href}>
      {content}
    </Link>
  );
}
